import { ErrorHandler, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { PatternAltitude } from '../models/pattern-altitude.model';


@Injectable()
export class PatternAltService {

  constructor(private _http: HttpClient,
              private _errorHandler: ErrorHandler) { }

  /**
   * updates specified entity via api
   * @param {number} airportID
   * @param {PatternAltitude} patternAlt
   * @return {Promise<any>}
   */
  putPatternAlt(airportID: number, patternAlt: PatternAltitude): Promise<any> {
    const URL = `${environment.airportsApiUrl}/airports/${airportID}/patternAlt/${patternAlt.patternAltId}`;
    try {
      const BODY = this._getPatternAltJSON(patternAlt);
      return this._http.put(URL, BODY).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  /**
   * adds specified entity via api
   * @param {number} airportID
   * @param {PatternAltitude} patternAlt
   * @return {Promise<any>}
   */
  postPatternAlt(airportID: number, patternAlt: PatternAltitude): Promise<any> {
    const URL = `${environment.airportsApiUrl}/airports/${airportID}/patternAlt/`;
    try {
      const BODY = this._getPatternAltJSON(patternAlt);
      return this._http.post(URL, BODY).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  /**
   * deletes specified entity via api
   * @param {number} airportID
   * @param {number} patternAltID
   * @return {Promise<any>}
   */
  deletePatternAlt(airportID: number, patternAltID: number): Promise<any> {
    const URL = `${environment.airportsApiUrl}/airports/${airportID}/patternAlt/${patternAltID}`;
    try {
      return this._http.delete(URL).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  /**
   * converts entity to json obj
   * @param {PatternAltitude} patternAlt
   * @return {any}
   * @private
   */
  _getPatternAltJSON (patternAlt: PatternAltitude): any {
    return {
      altitude: patternAlt.altitude,
      aircraftClass: PatternAltitude.formatAircraftClass(patternAlt.aircraftClass),
      sourceId: 5
    };
  }
}
